import React from 'react'
import { connect } from 'react-redux'
import { ORDER_FILTER_STATUS } from '@/constants/filter-type';
import Dropdown from '@/components/Dropdown/Dropdown';
import classnames from 'classnames'
import { formatFunctions } from '@/helpers/functions';
import { dataType } from '@/constants/data-type';
import '../../assets/styles/components/order/order-book.scss';
import { orderActions } from '@/actions/trading';
import { PARAMS } from '@/constants/params';
import { SERVICES_RESP } from '@/configurations';
import { openOrderCancelDialog } from '@/actions/app';
import { mobileSubLayoutAction } from '@/actions/app/mobileSubLayout.action';
import { ORDER_MODE } from "@/constants/app";
import CancelIcon from '@/assets/images/icons/mobiles/icon_cancel_normal@2x.png';
import ModifyIcon from '@/assets/images/icons/mobiles/icon_modify_normal@2x.png';
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env';
import { checkSessionAction } from '@/actions/auth'
import orderStatusData from '@/assets/data/order_status.json';
import { ORDER_FILTER_STATUS_GROUP_MOBILE } from '@/constants/filter-type';
import LoadingLayer from '@/components/Spinner/LoadingLayer';
import { LOADING_TYPE } from '@/constants/app';
import NoRow from '@/components/DataTable/CustomNoRow';

let IntervalRef;
class OrderBookMobile extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      orders: [],
      selectMarket: '',
      selectStatus: '',
      load: false
    }
  }

  render() {
    const { language } = this.props;
    const { orders, load } = this.state;
    return (
      <div className='order-book-mobile-container'>
        {this.renderOrderFilterDropdown()}
        <LoadingLayer load={load} type={LOADING_TYPE.BIG_IMG} />
        {orders.length > 0
          ? <div className="order-list">
            {orders.map(order =>
              <div key={order.orderID} className="order-item">
                <header>
                  <span onClick={() => this.handleViewDetail(order)}>{`${language.common_order_id} ${order.orderGroupID} >`}</span>
                  {/* <span>{language[`order_type_${order.orderType.toLowerCase()}`]}</span> */}
                  <span className={classnames(order.bs === 'B' ? 'buy-color' : 'sell-color')}>
                      {this.getOrderDirection(order)}
                  </span>
                </header>
                {order.marketID === 'FUND' ? <section className="info-list-fund">
                  <div className='instrument-id'>
                    <span>{order.instrumentID}</span>
                    <span>{language.lang === 'en_US'? order.instrumentName : order.instrumentChineseName}</span>
                  </div>
                  <div className='list-data'>
                    <div className="info-item">
                      <label>{language.common_ccy}</label>
                      <span>{order.currencyID}</span>
                    </div>
                    <div className="info-item">
                      <label>{language.common_market}</label>
                      <span>{order.marketID}</span>
                    </div>
                    <div className="info-item">
                      <label>{language.common_price}</label>
                      <span>{formatFunctions.dataFormat(order.price, dataType.STOP_PRICE)}</span>
                    </div>
                    <div className="info-item">
                      <label>{language.common_quantity}</label>
                      <span>{formatFunctions.dataFormat(order.qty, dataType.FUNDS_QUANTITY)}</span>
                    </div>
                    <div className="info-item">
                      <label>{language.common_filled_qty}</label>
                      <span>{formatFunctions.dataFormat(order.filledQty, dataType.FUNDS_QUANTITY)}</span>
                    </div>
                    <div className="info-item">
                      <label>{language.common_os_quantity}</label>
                      <span>{formatFunctions.dataFormat(order.osqty, dataType.FUNDS_QUANTITY)}</span>
                    </div>
                    <div className="info-item">
                      <label>{language.common_avg_price}</label>
                      <span>{formatFunctions.dataFormat(order.avgPrice, dataType.AVG_PRICE)}</span>
                    </div>
                    <div className="info-item">
                      <label>{language.common_cancelled_qty}</label>
                      <span>{formatFunctions.dataFormat(order.cancelQty, dataType.FUNDS_QUANTITY)}</span>
                    </div>
                  </div>
                </section> : <section className="info-list">
                  <div className='info-item order-id'>
                    <span>{`${order.marketID}.${order.instrumentID}`}</span>
                    <span>{language.lang === 'en_US'? order.instrumentName : order.instrumentChineseName}</span>
                  </div>
                  <div className='info-item order-type'>
                    {order.orderType === '-' ? '-' : language[`order_type_${order.orderType.toLowerCase()}`]}
                  </div>
                  <div className="info-item">
                    <label>{language.common_market}</label>
                    <span>{order.marketID}</span>
                  </div>
                  <div className="info-item">
                    <label>{language.common_quantity}</label>
                    <span>{formatFunctions.dataFormat(order.qty, dataType.NUMBER)}</span>
                  </div>
                  <div className="info-item">
                    <label>{language.common_ccy}</label>
                    <span>{order.currencyID}</span>
                  </div>
                  <div className="info-item">
                    <label>{language.common_os_quantity}</label>
                    <span>{formatFunctions.dataFormat(order.osqty, dataType.NUMBER)}</span>
                  </div>
                  <div className="info-item">
                    <label>{language.common_price}</label>
                    <span>{formatFunctions.dataFormat(order.price, dataType.CURRENCY)}</span>
                  </div>
                  <div className="info-item">
                    <label>{language.common_stop_price}</label>
                    <span>{formatFunctions.dataFormat(order.stopPrice, dataType.CURRENCY)}</span>
                  </div>
                  <div className="info-item">
                    <label>{language.common_filled_qty}</label>
                    <span>{formatFunctions.dataFormat(order.filledQty, dataType.NUMBER)}</span>
                  </div>                 
                  <div className="info-item">
                    <label>{language.common_avg_price}</label>
                    <span>{formatFunctions.dataFormat(order.avgPrice, dataType.CURRENCY)}</span>
                  </div>
                </section>}
                <div className="trade-time">
                  <label>{language.common_create_time + ':'}</label>
                  <span>{formatFunctions.dataFormat(order.inputTime, dataType.LONG_DATE)}</span>
                </div>
                <div className='info-bottom-item'>
                  <span>{language[`order_status_${order.status.toLowerCase()}`]}</span>
                  {(order.isCancelable === 'Y' || order.isModifiable === 'Y') && <div className="action">
                    {order.isCancelable === 'Y' &&
                      <button onClick={() => this.handleCancel(order)}>
                        <img src={CancelIcon} className='action-img'></img>
                        {language.common_cancel}
                      </button>}
                    {order.isModifiable === 'Y' &&
                      <button onClick={() => this.handleAmend(order)}>
                        <img src={ModifyIcon} className='action-img'></img>
                        {language.ipo_modify}
                      </button>}
                </div>}
                </div>
              </div>
            )}
          </div>
          : !load && <NoRow style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' , width :'100%'}} />
        }
      </div>
    )
  }

  getOrderDirection = (order) => {
    const {language} = this.props
    const bs = order.bs;
    const marketID = order.marketID;
    let direction = ''
    if(marketID === 'FUND') {
        if(bs === 'B'){
            direction = language.common_funds_subscription
        } else {
            direction = language.common_funds_redemption
        }   
    } else {
        if(bs === 'B'){
            direction = language.common_buy
        } else {
            direction = language.common_sell
        }
    }
    return direction
}

  handleViewDetail = (order) => {
    mobileSubLayoutAction.openOrderJournalDetail(order)
  }

  handleAmend = (order) => {
    mobileSubLayoutAction.openOrderModification(order, res => {
      if (res) {
        this.getData();
      }
    })
  }

  handleCancel = (order) => {
    mobileSubLayoutAction.openOrderCancel(order, (res,order) => {
      if (res) {
        mobileSubLayoutAction.openOrderConfirmStatus(res,order, ORDER_MODE.CANCEL);
        if (res.isSuccess === 'Y') {
          this.getData();
        }
      }
    })
  }

  renderOrderFilterDropdown() {
    const { language, markets } = this.props;
    const filterOptions = ORDER_FILTER_STATUS.reduce((acc, opt) => {
      acc.push({ label: language[opt.label], value: opt.value })
      return acc;
    }, [])
    let statusFilterOption = JSON.parse(JSON.stringify(ORDER_FILTER_STATUS_GROUP_MOBILE));
    statusFilterOption.map(item => {
      item.label = language[item.label]
    })
    return (
      <div className='order-book-filter'>
        <div className="ccy-filter">
            <Dropdown options={markets} style={{ height: 'unset' }}
            selectedOptions={[markets[0]]}
            onChange={(mrk) => this.onChangeMarket(mrk[0])}
            />
        </div>
        <div className='status-filter'>
            <Dropdown options={statusFilterOption} style={{ height: 'unset' }}
            selectedOptions={[statusFilterOption[0]]}
            onChange={(statusFilter) => this.onChangeStatus(statusFilter[0])}
            />
        </div>
      </div>
    )
  }

  onChangeMarket = (mrk) => {
    this.setState({
      selectMarket: mrk.value
    },() => {
      this.getData();
    })
  }

  onChangeStatus = (statusFilter) => {
    let statusString = "";
    if(statusFilter.value !== 'all'){
      const statusList = Object.keys(orderStatusData[statusFilter.value]);
      statusString = statusList.join(","); 
    }
    this.setState({
      selectStatus: statusString
    },() => {
      this.getData();
    })
  }

  handleFilter = (val) => {
    let status = '';
    switch (val.value) {
      case 'all': {
        status = '';
        break;
      }
      default: {
        status = val.value.toUpperCase();
        break;
      }
    }
    this.getData();
  }

  getData() {
    const { currentTradingAccount } = this.props
    const { selectMarket, selectStatus} = this.state
    this.setState({load: true})
    if (currentTradingAccount.clientID) {
      const params = {
        [PARAMS.CLIENT_ID]: currentTradingAccount.clientID,
        [PARAMS.TRADING_ACCOUNT_ID]: currentTradingAccount.clientID,
        [PARAMS.TRADING_ACCOUNT_SEQ]: currentTradingAccount.tradingAccSeq,
        [PARAMS.MARKET_ID]: selectMarket,
        [PARAMS.STATUS]: selectStatus
      }
      this.props.getOrderBook(params, res => {
        if (res.status === SERVICES_RESP.STATUS_OK) {
          if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
            this.setState({ orders: res.result.orderInfoList });
          }
        }
        this.setState({load: false})
      })
    }
  }

  componentDidMount() {
    const refreshTime = iTradeEnv?.pages?.trade?.orderEnquiry?.autoRefresh?.refreshTime ?? 0;
    this.getData();
    if(refreshTime !== 0){
      const refreshSession = iTradeEnv?.pages?.trade?.orderEnquiry?.autoRefresh?.refreshSession ?? true;
      const checkSessionTime = iTradeEnv?.pages?.trade?.orderEnquiry?.autoRefresh?.checkSessionTime ?? 300000;
      IntervalRef = setInterval(() => {
        this.props.checkSession('',res=>{}, error=>{
          if(SERVICES_RESP.SESSION_TIMEOUT.includes(error.result.errorCode))
          clearInterval(IntervalRef)
        })
      }, checkSessionTime);
      IntervalRef = setInterval(() => {
        if(this.props.stopQutoRefresh === 'true'){
          clearInterval(IntervalRef)
        } else {
          this.getData(this.state.status,refreshSession);
        }
      }, refreshTime);
    }
  }

  componentWillUnmount() {
    IntervalRef && clearInterval(IntervalRef)
  }
  
  componentDidUpdate(prevProps){
    const { currentTradingAccount } = this.props
    if (currentTradingAccount && prevProps.currentTradingAccount !== currentTradingAccount) {
      // if(JSON.stringify(prevProps.currentTradingAccount) !== "{}"){
        this.getData()
      // }
    }
  }
}

export default connect(
  state => ({
    language: state.app.language,
    currentTradingAccount: state.trade.currentTradingAccount,
    markets: [{ label: state.app.language.market_all, value: '' }, ...state.trade.markets]
  }),
  dispatch => ({
    checkSession: (p, c, b) => dispatch(checkSessionAction(p, c, b)),
    getOrderBook: (p, c) => dispatch(orderActions.getOrderBookAction(p, c))
  })
)(OrderBookMobile)
